// import React, { useState } from "react";
// import { Box, Card, Typography, Chip } from "@mui/material";
// import StorageIcon from "@mui/icons-material/Storage";
// import { URL } from "../config";

// const Backup = () => {
//   const [status, setStatus] = useState("ready");

//   const handleDatabaseBackup = async () => {
//     try {
//       setStatus("loading");
//       const response = await fetch(`${URL}/backup/download-database`);
//       if (!response.ok) throw new Error("Backup failed");

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `database-backup-${Date.now()}.sql`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);

//       setStatus("done");
//       setTimeout(() => setStatus("ready"), 3000);
//     } catch (error) {
//       console.log(error);
//       setStatus("ready");
//       alert("Backup failed");
//     }
//   };

//   const statusMap = {
//     ready:   { label: "Download",        color: "success" },
//     loading: { label: "Downloading…", color: "warning" },
//     done:    { label: "Done ✓",       color: "success" },
//   };

//   const { label, color } = statusMap[status];

//   return (
//     <Box
//       sx={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <Card
//         onClick={status === "ready" ? handleDatabaseBackup : undefined}
//         sx={{
//           width: 280,
//           cursor: status === "ready" ? "pointer" : "default",
//           border: "1px solid",
//           borderColor: "divider",
//           "&:hover": status === "ready" ? { bgcolor: "action.hover" } : {},
//           transition: "background 0.15s",
//           p: 3,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           gap: 1.5,
//         }}
//         elevation={0}
//       >
//         <Box
//           sx={{
//             width: 64,
//             height: 64,
//             borderRadius: "50%",
//             bgcolor: "#FFF3E0",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <StorageIcon sx={{ fontSize: 28, color: "#F57C00" }} />
//         </Box>

//         <Typography fontWeight={500}>Database backup</Typography>
//         <Typography variant="body2" color="text.secondary" textAlign="center">
//           Click to download a full .sql backup of the database
//         </Typography>

//         <Chip label={label} color={color} size="small" />
//       </Card>
//     </Box>
//   );
// };

// export default Backup;

import React, { useState } from "react";
import { Box, Card, Typography, Chip } from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";
import toast, { Toaster } from "react-hot-toast";
import { URL } from "../config";

const Backup = () => {
  const [status, setStatus] = useState("ready");

  const handleDatabaseBackup = async () => {
    try {
      setStatus("loading");
      const response = await fetch(`${URL}/backup/download-database`);
      if (!response.ok) throw new Error("Backup failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `database-backup-${Date.now()}.sql`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setStatus("done");
      toast.success("Database Backup Downloaded!", {
        style: {
          background: "#2e7d32",
          color: "#ffffff",
        },
        iconTheme: {
          primary: "#ffffff",
          secondary: "#2e7d32",
        },
      });
      setTimeout(() => setStatus("ready"), 3000);
    } catch (error) {
      console.log(error);
      setStatus("ready");
      toast.error("Backup failed!", {
        style: {
          background: "#c62828",
          color: "#ffffff",
        },
        iconTheme: {
          primary: "#ffffff",
          secondary: "#c62828",
        },
      });
    }
  };

  const statusMap = {
    ready:   { label: "Download",      color: "success" },
    loading: { label: "Downloading….",  color: "warning" },
    done:    { label: "Done ✓",        color: "success" },
  };

  const { label, color } = statusMap[status];

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{ duration: 3000 }}
      />

      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card
          onClick={status === "ready" ? handleDatabaseBackup : undefined}
          sx={{
            width: 280,
            cursor: status === "ready" ? "pointer" : "default",
            border: "1px solid",
            borderColor: "divider",
            "&:hover": status === "ready" ? { bgcolor: "action.hover" } : {},
            transition: "background 0.15s",
            p: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
          }}
          elevation={0}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              bgcolor: "#FFF3E0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <StorageIcon sx={{ fontSize: 28, color: "#F57C00" }} />
          </Box>

          <Typography fontWeight={500}>Database backup</Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Click to download a full .sql backup of the database
          </Typography>

          <Chip label={label} color={color} size="small" />
        </Card>
      </Box>
    </>
  );
};

export default Backup;